// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","532":"styles","774":"framework"}[chunkId] + "-" + {"230":"c6255db7ff66226988d2","256":"291b69945947a54fe086","532":"afeb47d056523ed0a6ae","774":"d3f2c7485dcdfc9d0e67"}[chunkId] + ".js";
};